import { Video as MatchboxVideo } from '@sparkpost/matchbox';

/**
 * Matchbox Video component.
 * @see https://design.sparkpost.com/components/video/
 */
const Video = MatchboxVideo;

export default Video;
